export default __webpack_public_path__ + "static/media/enjin-coin-enj-logo.e7356596.svg";